export class News {
    id: string;
    title: string;
    link: string;
    imageUrl: string;
    source: string;
    datePublished: Date;

    constructor() {
        this.id = '';
        this.title = '';
        this.link = '';
        this.imageUrl = '';
        this.source = '';
        this.datePublished = null;
    }
}